import { useEffect } from "react";
import { useRef, useState } from "react";
import { useHistory } from "react-router";
import { endPoints } from "../../config/end-points";
import useHttp from "../../hooks/use-http";
import { cuteToast } from "../UI/cute";
import Input from "../UI/Input";
import { access_specifier } from "../../config/app.config";

const UserForm = (props) => {
  const emailRef = useRef();
  const firstNameRef = useRef();
  const lastNameRef = useRef();
  const passwordRef = useRef();
  const creditsRef = useRef();
  var userDetail = props.userDetail;
  const [user, setUser] = useState({
    id: "",
    first_name: "",
    email: "",
    last_name: "",
    video_credits: null,
  });

  const [access, setAccess] = useState("1A,");

  const { sendRequest } = useHttp();

  const history = useHistory();

  useEffect(() => {
    if (userDetail) {
      setUser(userDetail);
      setAccess(userDetail.access);
    }
  }, [userDetail]);

  const default_access = {
    "9A": "Admin", //Admin
    "91" : "JV access", //JV;
  };

  // to remove admin access from access_specifier
  delete access_specifier["5"];

  const app_all_access = {...default_access,...access_specifier};

  // console.log(app_all_access)

  const handleChange = (e, access_id) => {
    var new_Access = access.split(",");

    if (!access.includes("1")) {
      cuteToast({
        type: "error",
        message: "",
        timer: 5000,
        title: "Primary Access Required",
      });
    }

    if (e.target.checked) {
      setAccess(access + access_id + ",");
    } else {
      var new_Access1 = new_Access.filter((access) => {
        return parseInt(access) !== parseInt(access_id);
      });
      setAccess(new_Access1.toString());
    }
    // console.log(access);
  };

  const checkAccess = (access1) => {
    // return access;
    // console.log(access1,access);
    if (access.includes(access1)) return "checked";
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(emailRef.current.val());

    if (!firstNameRef.current.val()) {
      firstNameRef.current.addClassName("form-control invalid");
      firstNameRef.current.focus();
      return false;
    } else {
      firstNameRef.current.addClassName("form-control");
    }

    if (!lastNameRef.current.val()) {
      lastNameRef.current.addClassName("form-control invalid");
      lastNameRef.current.focus();
      return false;
    } else {
      lastNameRef.current.addClassName("form-control");
    }

    if (!emailRef.current.val()) {
      emailRef.current.addClassName("form-control invalid");
      emailRef.current.focus();
      return false;
    } else {
      emailRef.current.addClassName("form-control");
    }

    if (!creditsRef.current.val()) {
      creditsRef.current.addClassName("form-control invalid");
      creditsRef.current.focus();
      return false;
    } else {
      creditsRef.current.addClassName("form-control");
    }

    if (!user.id)
      if (!passwordRef.current.val()) {
        passwordRef.current.addClassName("form-control invalid");
        passwordRef.current.focus();
        return false;
      } else {
        passwordRef.current.addClassName("form-control");
      }

    if (!access.includes("1A")) {
      cuteToast({
        type: "error",
        message: "",
        timer: 5000,
        title: "Primary Access Required",
      });

      return false;
    }

    const url = user.id
      ? endPoints.updateUser + "/" + user.id
      : endPoints.createUser;

    sendRequest(
      {
        url: url,
        method: "POST",
        body: {
          first_name: firstNameRef.current.val(),
          last_name: lastNameRef.current.val(),
          email: emailRef.current.val(),
          password: passwordRef.current.val(),
          access: access,
          video_credits: creditsRef.current.val(),
        },
      },
      (response) => {
        if (response.status === 202) {
          cuteToast({
            type: "error",
            message: "",
            timer: 5000,
            title: response.message,
          });
        } else {
          cuteToast({
            type: "success",
            message: "",
            timer: 5000,
            title: response.message,
          });

          if (!user.id) {
            setUser({
              first_name: "",
              email: "",
              last_name: "",
            });
            history.push("/users/");
          }
        }
      }
    );

    console.log("Form Submit");
  };

  return (
    <>
      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col-md-6">
            <div className="mb-3">
              <label className="form-label">First Name</label>
              <Input
                type="text"
                placeholder="Enter First Name"
                inputClass="form-control"
                value={user.first_name}
                ref={firstNameRef}
                onChange={(e) =>
                  setUser({ ...user, first_name: e.target.value })
                }
              />
            </div>
          </div>

          <div className="col-md-6">
            <div className="mb-3">
              <label className="form-label">Last Name</label>
              <Input
                type="text"
                placeholder="Enter Last Name"
                inputClass="form-control"
                value={user.last_name}
                onChange={(e) =>
                  setUser({ ...user, last_name: e.target.value })
                }
                ref={lastNameRef}
              />
            </div>
          </div>

          <div className="col-md-6">
            <div className="mb-3">
              <label className="form-label">Email</label>
              <Input
                type="text"
                placeholder="Enter Email"
                inputClass="form-control"
                ref={emailRef}
                value={user.email}
                onChange={(e) => setUser({ ...user, email: e.target.value })}
              />
            </div>
          </div>

          <div className="col-md-6">
            <div className="mb-3">
              <label className="form-label">Password</label>
              <Input
                type="password"
                placeholder="Enter Password"
                inputClass="form-control"
                ref={passwordRef}
              />
            </div>
          </div>
          <div className="col-md-12">
            <h6>Access : </h6>
            <ul>
              {Object.keys(app_all_access).map((access_id, index) => {
                const product_name = app_all_access[access_id];
                const check = checkAccess(access_id);
                // console.log(check, access_id);
                return (
                  <li key={index} className="access_span">
                    {check && (
                      <input
                        type="checkbox"
                        checked
                        onChange={(e) => {
                          handleChange(e, access_id);
                        }}
                      />
                    )}
                    {!check && (
                      <input
                        type="checkbox"
                        onChange={(e) => {
                          handleChange(e, access_id);
                        }}
                      />
                    )}{" "}
                    {product_name}
                  </li>
                );
              })}
            </ul>
          </div>
          <hr />
          <div className="col-md-12">
            <div className="mb-3">
              <label className="form-label"><b>Video Credits</b></label>
              <Input
                type="text"
                placeholder="Enter Credits"
                inputClass="form-control"
                ref={creditsRef}
                value={user.video_credits}
                onChange={(e) => setUser({ ...user, video_credits: e.target.value })}
              />
            </div>
          </div>
          <div className="col-md-12 mt-3">
            <button type="reset" className="btn btn-danger">
              Reset
            </button>
            <button type="submit" className="btn pull-right">
              {user.id ? "Update" : "Create"}
            </button>
          </div>
        </div>
      </form>
    </>
  );
};

export default UserForm;
